export default __webpack_public_path__ + "static/media/Instagram-47.cbacf7af.svg";